// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ElementAuthorityOutlinedSvg from "@fishx/icons-svg/es/asn/ElementAuthorityOutlined";
import FishxIcon from '../components/FishxIcon';

var ElementAuthorityOutlined = function ElementAuthorityOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ElementAuthorityOutlinedSvg
  }));
};

ElementAuthorityOutlined.displayName = 'ElementAuthorityOutlined';
export default React.forwardRef(ElementAuthorityOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ElementAuthorityOutlined.js
// module id = 2602
// module chunks = 0